<template>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <p class="col-span-full text-slate-400">Service Brands cards are coming soon.</p>
    </div>
</template>

<script lang="ts" setup></script>
